import { render, staticRenderFns } from "./PolicyRegular.vue?vue&type=template&id=44dc7874&scoped=true&"
import script from "./PolicyRegular.vue?vue&type=script&lang=js&"
export * from "./PolicyRegular.vue?vue&type=script&lang=js&"
import style0 from "./PolicyRegular.vue?vue&type=style&index=0&id=44dc7874&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dc7874",
  null
  
)

export default component.exports